import axiosInstance from "../../../api/axiosInstance";

export const fetchVocabularyList = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    );
    const res = await axiosInstance.get("/public/vocabulary", { params: cleaned });
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || "Failed to fetch vocabulary",
    };
  }
};

export const fetchVocabularyById = async (id) => {
  try {
    const res = await axiosInstance.get(`/public/vocabulary/${id}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || "Failed to fetch word",
    };
  }
};
